import Api from '../Api';

export const getColors = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/colors');
  dispatch({
    type: 'FETCH_COLORS',
    payload: data,
  });
};

export const clearColors = () => {
  return {
    type: 'CLEAR_COLORS',
  };
};

export const getColor = id => async dispatch => {
  const { data } = await Api.get(`/dropdowns/colors/${id}`);
  dispatch({
    type: 'FETCH_COLOR',
    payload: data,
  });
};

export const clearColor = () => {
  return {
    type: 'CLEAR_COLOR',
  };
};

export const getColorIds = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/colors/ids');
  dispatch({
    type: 'FETCH_COLOR_IDS',
    payload: data,
  });
};

export const clearColorIds = () => {
  return {
    type: 'CLEAR_COLOR_IDS',
  };
};
